<script>
import InvestorLayout from './components/MenuList'
import File from '@components/List/File'
import { nlToBr } from '@utils/index'
// import PDFObject from "pdfobject"
import createDownloadLink from '@utils/create-download-link'

export default {
  page() {
    return {
      title: `公司治理 | 投資人專區`,
    }
  },
  components: {
    InvestorLayout,
    File,
  },
  props: {
    defaultValue: {
      type: Array,
      default: () => {
        return []
      },
    },
    investorCompany: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: 'board-of-director',
      activeDirector: [0],
      activePolicy: [0],
      activeCommittee: [],
      directorList: [
        {
          position: '董事長',
          name: '林嘉勲',
          education: '交通大學電子研究所碩士<br>中文數位化技術推廣基金會董事長',
          experience:
            '兼任零宇投資(股)公司、愛就贏(股)公司及鋒一投資(股)公司董事長；亞諾法生技(股)公司獨立董事、薪酬委員及審計委員；彥陽科技(股)公司、潔客幫(股)公司及奇博科技(股)公司董事；愛微科(股)公司監察人',
        },
        {
          position: '董事',
          name: '姜有謨',
          education: '中國文化大學<br>零壹科技(股)公司副總經理',
          experience: '兼任本公司執行長；朔宇科技(股)公司董事長',
        },
        {
          position: '董事',
          name: '陳睿緒',
          education: '交通大學電子工程糸<br>交通大學管科研究所<br>花旗銀行台灣分行<br>Assistant Vice President<br>波士頓銀行台灣分行副總<br>友訊科技(股)公司總經理及財務長',
          experience: '兼任九康投資(股)公司及視傳科技(股)公司董事長；立端科技(股)公司董事',
        },
        {
          position: '董事',
          name: '亞洲世界電通(股)公司代表人：周植基',
          education: '台北市電腦公會理事',
          experience: '方元電子工業(股)公司董事長<br>中國電器(股)公司董事',
        },
        {
          position: '董事',
          name: '凱衛資訊(股)公司代表人：曾正哲',
          education: '中原大學資訊系',
          experience: '凱衛資訊(股)公司董事長',
        },
        {
          position: '獨立董事 ',
          name: '吳銘雄',
          education: '交通大學電子計算機系<br>彥陽科技(股)公司董事長',
          experience: '兼任彥陽科技(股)公司、酩陽實業(股)公司及衡陽投資有限公司董事長；Promaster(Brunei) Technology Corp. 董事',
        },
        {
          position: '獨立董事 ',
          name: '林健正',
          education: '依利諾大學材料博士<br>國立交通大學材料科學與工程學系所教授',
          experience: '國立交通大學材料科學與工程學系所教授<br>偉詮電子(股)公司薪酬委員',
        },
        {
          position: '獨立董事 ',
          name: '林銘遠',
          education: '美國喬治華盛頓大學MBA<br>國立政治大學財稅系<br>守護天使管理顧問(股)公司總經理及創辦人<br>興利投資(股)公司總經理及創辦人',
          experience: '兼任守護天使管理顧問(股)公司、興利投資(股)公司、中泰陶瓷(股)公司及臺灣時尚發展(股)公司董事',
        },
      ],
      committeeList: [
        {
          name: '薪酬委員會',
          alias: 'salary',
          nember: '依據本公司薪酬委員會組織章程，該委員會成員人數為三人，由本公司董事會決議委任之，目前，本公司薪酬委員會由全體三位獨立董事組成。',
          duty:
            '<ul><li>訂定並定期檢討董事、監察人及經理人績效評估與薪資報酬之政策、制度、標準與結構。</li><li>定期評估董事、監察人及經理人之績效目標達成情形並訂定薪資報酬。</li><li>不定期檢討薪酬委員會組織規程並提出修正建議。</li></ul>',
          info: {
            title: '運作情形資訊',
            file: `/site-build/files/薪酬委員會運作情形資訊.pdf`,
          },
        },
        {
          name: '審計委員會',
          alias: 'audit',
          nember: '本公司審計委員會依法由全體獨立董事組成。',
          duty:
            '依本公司「審計委員會組織規程」運作，以下列事項之監督為主要目的：<ul><li>公司財務報表之允當表達。</li><li>簽證會計師之選（解）任及獨立性與績效。</li><li>公司內部控制之有效實施。</li><li>公司遵循相關法令及規則。</li><li>公司存在或潛在風險之管控。</li></ul>',
          info: {
            title: '運作情形資訊',
            file: `/site-build/files/審計委員會運作情形資訊.pdf`,
          },
        },
      ],
      governanceList: [
        {
          name: '員工福利及工作環境',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.benefits || [],
        },
        {
          name: '內部稽核',
          image: require('@assets/images/about/introduction_1.jpg'),
          text: this.investorCompany?.governance?.audit,
        },
        {
          name: '資訊安全風險管理架構',
          image: require('@assets/images/about/introduction_1.jpg'),
          text: this.investorCompany?.governance?.risk,
        },
        {
          name: '資訊安全政策及具體管理方案',
          image: require('@assets/images/about/introduction_1.jpg'),
          text: this.investorCompany?.governance?.security,
        },
        {
          name: '供應商管理措施',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.supplier || [],
        },
        {
          name: '人權政策落實情形',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.humanpolicy || [],
        },
        {
          name: '誠信經營運作及執行情形',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.operation || [],
        },
        {
          name: '風險管理運作情形',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.riskManagement || [],
        },
        {
          name: '其他事項',
          image: require('@assets/images/about/introduction_1.jpg'),
          file: this.investorCompany.governance?.other || [],
        },
      ],
      dialogVisible: false,
    }
  },
  computed: {
    ruleList() {
      return this.defaultValue.map((item) => {
        return {
          ...item.files[0],
          title: item.title,
        }
      })
    },
  },
  methods: {
    nlToBr(item) {
      return nlToBr(item)
    },
    async handleClickItem(file) {
      this.filedoading = true
      // const isPdf = file.contentType === 'application/pdf';
      // const isSupportPdf = PDFObject.supportsPDFs;
      // if(isPdf && isSupportPdf) {
      //   const routeItem = this.$router.resolve({
      //     name: 'media',
      //     params: {
      //       mediaUuid: file.uuid
      //     }
      //   });

      //   window.open(routeItem.href, '_blank');
      // } else {
      const response = await this.$store.dispatch('global/fetchFile', {
        url: file.downloadLink,
        responseType: 'blob',
      })

      createDownloadLink(file.title || file.name, response)
      // }
      this.filedoading = false
    },
  },
}
</script>
<template>
  <InvestorLayout>
    <div :class="$style.companyPolicy">
      <section v-if="investorCompany['structure-image']" class="container section">
        <BaseSectionTitle title="公司治理架構" class="text-center" />
        <div class="companyPolicy__img">
          <img :src="investorCompany['structure-image']" alt="" />
        </div>
        <BaseButton v-if="!!investorCompany['structure-image']" class="isStylePrimary isSmall isFull isRadius mt-4 mb-5 d-md-none" @click="dialogVisible = !dialogVisible">
          <i class="fal fa-search-plus"></i> 查看大圖
        </BaseButton>
      </section>
      <!-- 底下 tabs -->
      <section class="section companyPolicy__content">
        <div class="container">
          <el-tabs v-model="activeName" stretch class="isStyleBase">
            <!-- 董事會 -->
            <el-tab-pane label="董事會" name="board-of-director" class="director">
              <div class="director__introduction">
                <h4 class=" text-base md:text-2xl">{{ investorCompany['board-of-director'].title || '零壹科技股份有限公司 董事會成員簡歷' }}</h4>
                <div class="color-gray-6 mt-3 text-base md:text-lg">
                  <p v-html="nlToBr(investorCompany['board-of-director'].description) || ''"></p>
                  <template v-if="!!investorCompany['board-of-director']['policy-file'].length">
                    <File v-for="(file, $index) in investorCompany['board-of-director']['policy-file']" :key="$index" :item="file" class="mb-2" style="max-width: 280px" />
                  </template>
                </div>
              </div>
              <div class="director__accordion">
                <el-collapse v-if="!!investorCompany['board-of-director'].member.length" v-model="activeDirector" class="isStyleBase">
                  <el-collapse-item v-for="(item, $index) in investorCompany['board-of-director'].member" :key="$index" :name="$index">
                    <template slot="title">
                      <div class="title__box">
                        <h4 class="title__name">{{ item.name }}</h4>
                        <span class="color-gray-6 title__position">{{ item.title }}</span>
                      </div>
                    </template>
                    <div class="row">
                      <div class="col-md-6 text-base md:text-lg">
                        <p class="color-gray-6 mb-3">主要經(學)歷</p>
                        <p class="my-0" v-html="nlToBr(item.career)"></p>
                      </div>
                      <div class="col-md-6 text-base md:text-lg">
                        <p class="color-gray-6 mb-3">目前兼任本公司及其他公司之職務</p>
                        <p class="my-0" v-html="nlToBr(item.concurrently)"></p>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-tab-pane>
            <!-- 委員會 -->
            <el-tab-pane label="委員會" name="committee" class="committee">
              <div v-if="investorCompany.committee" class="row committee__list">
                <div v-for="(item, $index) in investorCompany.committee" :key="$index" class="col-lg-6 committee__item mb-2">
                  <div class="committee__box">
                    <BaseSectionTitle2 :title="item.title" />
                    <el-collapse v-model="activeCommittee[$index]" class="isStyleBase">
                      <el-collapse-item title="組織成員" name="0">
                        <div>{{ nlToBr(item.member) }}</div>
                      </el-collapse-item>
                      <el-collapse-item title="職責" name="2">
                        <div v-html="nlToBr(item.response)"></div>
                      </el-collapse-item>
                      <el-collapse-item title="運作情形資訊" name="3">
                        <template v-if="!!item.status.length">
                          <File v-for="(file, $index2) in item.status" :key="$index2" :item="file" class="mb-2" />
                        </template>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <!-- 重要規章 -->
            <el-tab-pane label="重要規章" name="rule" class="rule">
              <div class="row rule__list">
                <div v-if="!!investorCompany.rules['meeting-rule'][0]" class="col-md-4 col-12 rule__item">
                  <a href="javascript:;" class="rule__box d-block" @click="handleClickItem(investorCompany.rules['meeting-rule'][0])">
                    <div class="boxInner">
                      <div class="icon color-primary">
                        <img :src="require(`@src/assets/images/investor/sharehoders/icon-4.svg`)" alt="" />
                      </div>
                      <p class="title mb-0 mt-2 text-gray-7">公司章程</p>
                    </div>
                  </a>
                </div>
                <div v-if="!!investorCompany.rules['meeting-rule'][0]" class="col-md-4 col-12">
                  <a href="javascript:;" class="rule__box d-block" @click="handleClickItem(investorCompany.rules['election'][0])">
                    <div class="boxInner">
                      <div class="icon color-primary">
                        <img :src="require(`@src/assets/images/investor/sharehoders/icon-5.svg`)" alt="" />
                      </div>
                      <p class="title mb-0 mt-2 text-gray-7">公司治理實務守則</p>
                    </div>
                  </a>
                </div>
                <div v-if="!!investorCompany.rules['communication'][0]" class="col-md-4 col-12">
                  <a href="javascript:;" class="rule__box d-block" @click="handleClickItem(investorCompany.rules['communication'][0])">
                    <div class="boxInner">
                      <div class="icon color-primary">
                        <img :src="require(`@src/assets/images/investor/sharehoders/icon-1.svg`)" alt="" />
                      </div>
                      <p class="title mb-0 mt-2 text-gray-7">董事會議事規範</p>
                    </div>
                  </a>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div v-for="(item, $index) in ruleList" :key="$index" class="col-md-4 col-sm-6 col-12 rule__item--small">
                      <File v-if="defaultValue.length" :item="item" />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="investorCompany.rules.description" class="mt-4 border-top pt-5 color-gray-6 notice" v-html="investorCompany.rules.description"> </div>
            </el-tab-pane>
            <!--  -->
            <el-tab-pane label="公司治理執行情形" name="governance" class="policy">
              <div class="policy__accordion">
                <el-collapse v-model="activePolicy" class="isStyleBase isStyleTransparent">
                  <el-collapse-item v-for="(item, $index) in governanceList" :key="$index" :name="$index">
                    <template slot="title">
                      <div class="title__box">
                        <h4 class="title__name text-lg md:text-xl py-4 font-regular">{{ item.name }}</h4>
                      </div>
                    </template>
                    <div class="row policy__item">
                      <div class="col-12">
                        <div v-if="item.file" class="policy__item__employeeBenefits">
                          <template v-if="!!item.file.length">
                            <File v-for="(fileItem, $index2) in item.file" :key="$index2" :item="fileItem" />
                          </template>
                        </div>
                        <div v-else class="content" v-html="nlToBr(item.text)"></div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </section>
      <template v-if="activeName === 'governance'">
        <section class="companyPolicy__regulations section ">
          <div class="container">
            <h4 class="pb-4 border-bottom secTitle text-lg md:text-xl">內部稽核之組織運作及人員任免</h4>
            <div v-if="investorCompany.governance.appoint" class="content color-gray-6" v-html="nlToBr(investorCompany.governance.appoint)"></div>

            <h4 class="pb-4 border-bottom secTitle text-lg md:text-xl ">資訊安全風險管理架構、資訊安全政策及具體管理方案</h4>
            <div class="content color-gray-6 isStyleInfo">
              <template v-if="!!investorCompany.governance.file.length">
                <File v-for="(fileItem, $index3) in investorCompany.governance.file" :key="$index3" :item="fileItem" class="mb-2" />
              </template>
            </div>
          </div>
        </section>
      </template>
      <el-dialog :visible.sync="dialogVisible" width="1200px" class="isStyleBigImg">
        <img :src="investorCompany['structure-image']" alt="" />
      </el-dialog>
    </div>
  </InvestorLayout>
</template>
<style lang="scss" module>
.companyPolicy {
  :global {
    .companyPolicy {
      &__img {
        // box-shadow: 0 0 30px rgba(141, 141, 141, 0.15);
      }

      &__content {
        background: $color-gray-2;

        .director {
          &__introduction {
            width: 100%;
            max-width: 900px;
            margin: 0 auto;
            line-height: 2;
            text-align: center;
          }

          &__accordion {
            padding: 50px 114px 80px 114px;
            margin-top: 3.265rem;
            background: #fff;
            border: 1px solid #e6e6e6;
            border-radius: 0 2px 2px 0;
            box-shadow: 0 0 8px rgba(141, 141, 141, 0.15);

            @include max-md {
              padding: 1rem;
            }
          }

          .title {
            &__box {
              // padding-top: 30px;
              // padding-bottom: 30px;
            }

            &__name {
              margin-bottom: 14px;
              font-size: 1.5rem;
              transition: 0.3s;

              @include max-md {
                font-size: 1rem;
              }
            }

            &__position {
              font-size: 1rem;
              font-weight: 400;
            }
          }

          .el-collapse-item {
            &__header {
              align-items: flex-start;
              padding: 30px 10%;

              &.is-active,
              &:hover {
                .title {
                  &__box {
                    // padding-top: 30px;
                    // padding-bottom: 30px;
                  }

                  &__name {
                    color: $color-primary;
                  }
                }
              }
            }

            &__wrap {
              padding: 40px 15% 40px 10%;
              background: #f5f5f5;
            }

            &__content {
              padding-bottom: 0;
              font-size: 1.125rem;

              @include max-md {
                font-size: 1rem;
              }
            }
          }
        }

        .committee {
          &__item {
            @include max-md {
              &:not(:first-child) {
                margin-top: 1.5rem;
              }
            }
          }

          &__box {
            padding: 80px 114px;
            background: #fff 0% 0% no-repeat padding-box;
            border: 1px solid #e6e6e6;
            border-radius: 0 2px 2px 0;
            box-shadow: 0 0 8px #21455829;
            @include max-xl {
              padding: 60px 94px;
            }
            @include max-md {
              padding: 40px 20px;
            }
          }

          .el-collapse-item {
            &__header {
              padding-top: 30px;
              padding-bottom: 30px;
              font-size: 1.25rem;
              font-weight: 400;
              @include max-md {
                font-size: 1.125rem;
              }
              // &.is-active, &:hover {
              //   color: $color-primary;
              // }
            }

            &__wrap {
              padding-top: 24px;
              padding-bottom: 0;
            }

            &__content {
              font-size: 1rem;
              color: $color-gray-6;
              @include max-md {
                font-size: 0.875rem;
              }

              ul {
                padding-left: 20px;
                list-style: none;

                li {
                  position: relative;
                  padding-left: 10px;
                }

                li::before {
                  position: absolute;
                  top: 10px;
                  left: -18px;
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  font-weight: bold;
                  color: $color-primary;
                  content: '';
                  background: $color-primary;
                  border-radius: 50%;
                }
              }
            }
          }
        }

        .rule {
          &__item {
            &--small {
              margin-bottom: 40px;

              @include max-md {
                margin-bottom: 20px;
              }
            }
          }

          &__box {
            position: relative;
            display: block;
            width: 100%;
            padding-top: 50.4%;
            margin-bottom: 80px;
            cursor: pointer;
            background: #fff;
            border: 1px solid transparent;
            border-radius: 2px;
            box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);
            transition: 0.3s;

            @media screen and (max-width: 1200px) {
              // padding-top: 25%;
            }

            @include max-md {
              margin-bottom: 40px;
            }

            .boxInner {
              position: absolute;
              top: 0%;
              left: 50%;
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              height: 100%;
              // margin-top: 40px;
              // margin-bottom: 40px;
              text-align: center;
              text-indent: 0.25em;
              transform: translateX(-50%);
              padding-top: 2.5rem;
              @include max-xl {
                padding-top: 1.5rem;
              }
              @include max-md {
                padding-top: 0;
                justify-content: center;
              }
            }

            .icon {
              font-size: 2.5rem;
              transition: 0.3s;

              @include max-lg {
                font-size: 1.3rem;
                img {
                  width: 50px;
                }
              }
            }

            .title {
              // margin-top: 24px;
              transition: 0.3s;
              padding: 0 2rem;
              @include max-lg {
                font-size: 16px;
              }

              // @include max-2sm {
              //   font-size: 12px;
              // }
            }

            &:hover {
              color: $color-primary-hover;
              border: 1px solid $color-primary;

              .title {
                color: $color-primary;
              }

              .icon {
                color: $color-primary;
              }
            }
          }

          .notice {
            font-size: 1rem;
            line-height: 1.75;
          }
        }

        .policy {
          &__introduction {
          }

          &__item {
            padding-top: 2.5rem;

            .left {
              min-height: 20.1rem;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }

            .right {
              display: flex;
              align-items: center;
              padding-left: 2.2rem;

              @include max-md {
                padding-top: 2rem;
                padding-left: 19px;
              }

              .content {
              }
            }

            &__employeeBenefits {
              width: 25%;

              @include max-lg {
                width: 100%;
              }
            }
            &__employeeInfo {
              width: 27%;
              @include max-lg {
                width: 100%;
              }
            }
          }
        }
      }

      &__regulations {
        .secTitle {
          margin-top: 80px;
        }

        .content {
          margin-top: 24px;
          font-size: 1rem;
          line-height: 1.75;
          @include max-md {
            font-size: 0.875rem;
          }

          p {
            margin-bottom: 35px;
          }

          .subTitle {
            font-size: 1.125rem;
            @include max-md {
              font-size: 1rem;
            }
          }
          &.isStyleInfo {
            width: 27%;
            @include max-md {
              width: 100%;
            }
          }
        }
      }
    }
    .isStyleBigImg {
      .el-dialog {
        max-width: inherit;
        overflow: auto;
      }
    }
  }
}
</style>
